import axios from 'axios';
import { ROOT_API_URL } from '../../api-config';
import { auth } from '../../services/auth.service';

export const GET_STATES = 'GET_STATES';
export const SELECT_STATE = 'SELECT_STATE';
export const GET_TOASTR = 'GET_TOASTR';
export const IS_LOADING = 'IS_LOADING';
export const CHECK_EMAIL = 'CHECK_EMAIL';
export const GET_REGIONS = 'GET_REGIONS';
export const GET_DISTRICTS = 'GET_DISTRICTS';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_COLORS = 'GET_COLORS';
export const GET_SIZES = 'GET_SIZES';
export const GET_PRODUCTTYPES = 'GET_PRODUCTTYPES';
export const REMOVE_EMAIL_MESSAGE = 'REMOVE_EMAIL_MESSAGE';
export const CHECK_ADDRESS = 'CHECK_ADDRESS';
export const GET_PAYMENT_TYPES = 'GET_PAYMENT_TYPES';
export const GET_BATCH_STATUSES = 'GET_BATCH_STATUSES';
export const GET_BATCH_TYPES = 'GET_BATCH_TYPES';
export const RESET_PASSWORD_SUBMIT = 'RESET_PASSWORD_SUBMIT';
export const GET_REGION_AND_DISTRICTSUPERVISOR = 'GET_REGION_AND_DISTRICTSUPERVISOR';

//Loaders
export const SET_ACCOUNTLOADER = 'SET_ACCOUNTLOADER';
export const SET_MEMBERSHIPLOADER = 'SET_MEMBERSHIPLOADER';
export const SET_PURCHASEHISTORYLOADER = 'SET_PURCHASEHISTORYLOADER';


export function fetchStates() {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/lookup/getstates`, { headers: auth.authHeader() })
            .then((response) => dispatch({
                type: GET_STATES,
                states: response.data
            })).catch((response) => {
                console.log(response);
            })
    }
}

export function GetRegionAndDistrictSupervisor(membershipID) {
    var id = Number(membershipID)
	return function(dispatch) {
        axios.get(`${ROOT_API_URL}/ManageRegions/GetRegionAndDistrictSupervisor?id=${id}`, { headers: auth.authHeader() })
        .then((response) => {
			dispatch({
				type: GET_REGION_AND_DISTRICTSUPERVISOR,
                supervisors : response.data
			})})
        .catch((response) => {
            console.log(response);
        });
    }
}

export function selectState(selectedStateObject) {
    return function (dispatch) {
        dispatch({
            type: SELECT_STATE,
            selectedState: selectedStateObject
        })
    }
}


export function loader(status) {
	return function(dispatch) {		
		dispatch({
			type: IS_LOADING,
			loading: status
		})			
	};
}

export function setAccountLoader(status) {
    return function (dispatch) {
        dispatch({
            type: SET_ACCOUNTLOADER,
            loader: status
        })
    };
}
export function setMembershipLoader(status) {
    return function (dispatch) {
        dispatch({
            type: SET_MEMBERSHIPLOADER,
            loader: status
        })
    };
}
export function setPHLoader(status) {
    return function (dispatch) {
        dispatch({
            type: SET_PURCHASEHISTORYLOADER,
            loader: status
        })
    };
}

export function toastr(visible, text, color, timeout = true) {
	return function(dispatch) {		
		dispatch({
			type: GET_TOASTR,
			visible: visible,
			message: text,
			color:color
        })

        if (timeout) {
            setTimeout(() => {
                dispatch({
                    type: GET_TOASTR,
                    visible: false,
                    message: ""
                })
            }, 5000);
        }
	};
}

export function checkEmailCall(email) {
	return function(dispatch) {
        // axios.get(`${ROOT_API_URL}/ManageDistrict/CheckUserByEmail?email=${email}`, { headers: auth.authHeader() })

        axios.post(`${ROOT_API_URL}/ManageDistrict/CheckUserByEmail`,
            {
                email: email
            },
            {
                headers: auth.authHeader()
            }
        )
        .then((response) => {
			dispatch({
				type: CHECK_EMAIL,
                emailMessage: response.data.message,
                emailExists : response.data.isSuccess
			})})
        .catch((response) => {
            console.log(response);
        });
    }
}

export function RemoveEmailMessage() {
	return function(dispatch) {
        dispatch({
            type: REMOVE_EMAIL_MESSAGE,
            emailMessage: "",
            emailExists : true
        })
    }
}

export function getRegions() {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/lookup/GetAllRegions `, { headers: auth.authHeader() })
            .then((response) => dispatch({
                type: GET_REGIONS,
                regions: response.data
            }))
            .catch((response) => {
                console.log(response);
            });
    }
}

export function getBatchTypes() {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/ManageBatches/GetBatchTypes `, { headers: auth.authHeader() })
            .then((response) => dispatch({
                type: GET_BATCH_TYPES,
                payload: response.data
            }))
            .catch((response) => {
                console.log(response);
            });
    }
}

export function getDistricts(regionId) {
    return function (dispatch) {
        if (regionId) {
            axios.get(`${ROOT_API_URL}/lookup/GetDistrictsByRegion?regionId=` + regionId, { headers: auth.authHeader() })
                .then((response) => dispatch({
                    type: GET_DISTRICTS,
                    districts: response.data
                }))
                .catch((response) => {
                    console.log(response);
                });
        } else {
            dispatch({
                type: GET_DISTRICTS,
                districts: []
            })
        }
    }
}

export function geteventCategories() {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/events/GetEventCategories`, { headers: auth.authHeader() })
            .then((response) => dispatch({
                type: GET_CATEGORIES,
                payload: response.data
            }))
            .catch((response) => {
                console.log(response);
            });
    }
}

export function getColors() {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/lookup/GetColors `, { headers: auth.authHeader() })
            .then((response) => dispatch({
                type: GET_COLORS,
                payload: response.data
            }))
            .catch((response) => {
                console.log(response);
            });
    }
}

export function getSizes() {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/lookup/GetSizes `, { headers: auth.authHeader() })
            .then((response) => dispatch({
                type: GET_SIZES,
                payload: response.data
            }))
            .catch((response) => {
                console.log(response);
            });
    }
}

export function getProductTypes() {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/Lookup/GetProductTypes`, { headers: auth.authHeader() })
        .then((response) => dispatch({
            type: GET_PRODUCTTYPES,
            payload: response.data
        }))
        .catch((response) => {
            console.log(response);
        });
    }
}

export function checkAddressCall(model){
    return function(dispatch) {
        const data = {
            State: model.state,
            City: model.city,
            Street1: model.billingAddress1,
            Street2: model.billingAddress2,
            Zip: model.zip,
        }

        const headers = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
            }}

        axios.post(`${ROOT_API_URL}/GoogleAddress/GetNormalizedAddress`, data, { headers: auth.authHeader() })
        .then((response) => {
			dispatch({
				type: CHECK_ADDRESS,
                payload: response.data,
			})})
        .catch((response) => {
            console.log(response);
        });
    }
}

export function getPaymentTypes() {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/Lookup/GetPaymentTypes`, { headers: auth.authHeader() })
            .then((response) => {
                dispatch({
                    type: GET_PAYMENT_TYPES,
                    payload: response.data
                })
            })
            .catch((response) => {
                console.log(response);
            });
    }
}

export function getBatchStatuses() {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/ManageBatches/GetBatchStatus`, { headers: auth.authHeader() })
            .then((response) => {
                dispatch({
                    type: GET_BATCH_STATUSES,
                    payload: response.data
                })
            })
            .catch((response) => {
                console.log(response);
            });
    }
}

export function resetPasswordSubmit(email) {
    return function (dispatch) {
        axios.post(`${ROOT_API_URL}/account/ForgotPassword`, {
            'email': email
        }).then((response) => {
            if (typeof (response.data.issuccess) == "undefined" || response.data.issuccess == true) {
                var emailSentObj = {
                    emailSent: true,
                    error: false
                }

                dispatch({
                    type: RESET_PASSWORD_SUBMIT,
                    payload: emailSentObj
                })
            }
            else {
                var emailSentObj = {
                    emailSent: false,
                    error: true
                }

                dispatch({
                    type: RESET_PASSWORD_SUBMIT,
                    payload: emailSentObj
                })
            }
            //this.state.emailSent = true;
            // if good response need to show "email has been sent" otherwise show an error
        }, (error) => {
            var emailSentObj = {
                emailSent: false,
                error: true
            }

            dispatch({
                type: RESET_PASSWORD_SUBMIT,
                payload: emailSentObj
            })
        });
    }
}

export function resetInitialPassword() {
    return function (dispatch) {
        dispatch({
            type: RESET_PASSWORD_SUBMIT,
            payload: {
                emailSent: false,
                error: false
            }
       })

    }
}
